var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollegeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38369",
    "data-name": "Group 38369",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.982,
    height: 33.896,
    viewBox: "0 0 35.982 33.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M26.987,0l9,16.948-9,16.948H9L0,16.948,9,0Z",
    transform: "translate(0 0)",
    fill: "#ac9700"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "college-svgrepo-com",
    transform: "translate(7.739 5.857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36754",
    "data-name": "Group 36754",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36753",
    "data-name": "Group 36753",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64995",
    "data-name": "Path 64995",
    d: "M365.825,857.677v1.755a.425.425,0,0,0,.424.424H368a.419.419,0,0,0,.42-.424v-1.755a.434.434,0,0,0-.127-.305l-.873-.843a.419.419,0,0,0-.589,0l-.873.843A.434.434,0,0,0,365.825,857.677Zm.848.178.449-.437.449.437v1.153h-.9Z",
    transform: "translate(-350.32 -844.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64996",
    "data-name": "Path 64996",
    d: "M215.023,805.185a.42.42,0,0,0-.6,0l-.873.877a.41.41,0,0,0-.123.3v1.3a.425.425,0,0,0,.424.424H215.6a.425.425,0,0,0,.424-.424v-1.3a.417.417,0,0,0-.123-.3Zm.148,2.051h-.9v-.7l.449-.449.449.449Z",
    transform: "translate(-204.379 -795.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64997",
    "data-name": "Path 64997",
    d: "M62.025,856.529l-.873.843a.434.434,0,0,0-.127.305v1.755a.425.425,0,0,0,.424.424h1.742a.422.422,0,0,0,.424-.424v-1.755a.434.434,0,0,0-.127-.305l-.873-.843A.419.419,0,0,0,62.025,856.529Zm.746,2.479h-.9v-1.153l.449-.437.449.437Z",
    transform: "translate(-58.438 -844.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64998",
    "data-name": "Path 64998",
    d: "M213.548,713.962a.41.41,0,0,0-.123.3v1.3a.425.425,0,0,0,.424.424H215.6a.422.422,0,0,0,.424-.424v-1.3a.417.417,0,0,0-.123-.3l-.873-.877a.42.42,0,0,0-.6,0Zm1.623.47v.7h-.9v-.7l.449-.449Z",
    transform: "translate(-204.379 -706.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64999",
    "data-name": "Path 64999",
    d: "M20.558,581.481h0l-5.332-5.2a.429.429,0,0,0-.538-.047l-1.051.725-2.874-3.141v-.712h3.454a.425.425,0,0,0,.424-.424v-2.6a.425.425,0,0,0-.424-.424H10.343a.425.425,0,0,0-.424.424v3.734l-2.929,3.2-1.157-.788a.424.424,0,0,0-.538.051L1,580.608l-.873.877a.422.422,0,0,0,0,.6.432.432,0,0,0,.3.123.421.421,0,0,0,.3-.127l.148-.148v5.506a.425.425,0,0,0,.424.424h18.09a.425.425,0,0,0,.424-.424v-5.5l.153.148a.42.42,0,0,0,.3.119.43.43,0,0,0,.305-.127A.422.422,0,0,0,20.558,581.481Zm-9.791-10.973H13.8v1.75H10.767Zm-5.879,9.439a.426.426,0,0,0,.6-.025l.555-.606v7.7H1.718v-5.934h0l3.925-3.95.767.521-1.551,1.7A.426.426,0,0,0,4.888,579.947Zm6.324,7.07H9.474v-1.725l.869-.763.869.763Zm2.585,0H12.06V585.1a.422.422,0,0,0-.144-.318h0l-1.293-1.136a.425.425,0,0,0-.559,0L8.77,584.779a.416.416,0,0,0-.144.318v1.916H6.889v-8.625l3.454-3.776,3.454,3.776v8.625Zm2.022-7.655L14.208,577.6l.67-.462,4.082,3.98v5.9H14.641v-7.7l.555.606a.422.422,0,0,0,.314.14.427.427,0,0,0,.284-.11A.419.419,0,0,0,15.819,579.358Z",
    transform: "translate(0 -569.66)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeIcon);
export default __webpack_public_path__ + "static/media/collegeIcon.ed8309194fb7cb3bb208b63ad97e7949.svg";
export { ForwardRef as ReactComponent };